import { useState } from 'react';
import { FormField, FormInput, FormSectionTitle, FormActions, BaseModal, useToast } from '@practium/ui';
import { useCreateActiveIngredient } from '@practium/features/api';
import styles from '../../ProductFormCard/ProductFormCard.module.css';

interface AddActiveIngredientModalProps {
	isOpen: boolean;
	onClose: () => void;
	onCreated: (name: string) => void;
}

export const AddActiveIngredientModal = ({ isOpen, onClose, onCreated }: AddActiveIngredientModalProps) => {
	const toast = useToast();
	const [name, setName] = useState('');
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const { mutateAsync: createActiveIngredient } = useCreateActiveIngredient();

	const handleSubmit = async () => {
		const trimmed = name.trim();
		if (!trimmed) {
			setError('Nome é obrigatório');
			return;
		}
		setError('');
		setIsLoading(true);
		try {
			const activeIngredient = await createActiveIngredient({ name: trimmed });
			toast.success('Ingrediente ativo criado com sucesso!');
			onCreated(activeIngredient.name);
			onClose();
		} catch (err) {
			toast.error(err instanceof Error ? err.message : 'Erro ao criar ingrediente ativo');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title="Novo Ingrediente Ativo"
			isLoading={isLoading}
			actions={
				<FormActions
					onCancel={onClose}
					onSave={handleSubmit}
					isLoading={isLoading}
				/>
			}
		>
			<div className={styles.form}>
				<div className={styles.section}>
					<FormSectionTitle>Informações Gerais</FormSectionTitle>
					<div className={styles.sectionFields}>
						<FormField label="Nome" required error={error}>
							<FormInput
								placeholder="Ex.: Azoxistrobina"
								value={name}
								onChange={(e) => setName(e.target.value)}
								hasError={!!error}
							/>
						</FormField>
					</div>
				</div>
			</div>
		</BaseModal>
	);
};
